export const templateListFields = [
  {
    label: 'Nama Template',
    key: 'name',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: 'Deskripsi',
    key: 'description',
    isSortable: true,
  },
  {
    label: 'Dibuat Oleh',
    key: 'created_by',
    isSortable: true,
  },
  {
    label: 'Tanggal Dibuat',
    key: 'created_on',
    isSortable: true,
  },
]
